/* tslint:disable */
/* eslint-disable */
import {
  HttpClient,
  HttpContext,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { LanguageListModel } from '../../models/language-list-model';

export function listLanguagesGet(
  http: HttpClient,
  rootUrl: string,
  headers: HttpHeaders,
  context?: HttpContext,
): Observable<StrictHttpResponse<LanguageListModel>> {
  const rb = new RequestBuilder(rootUrl, listLanguagesGet.PATH, 'get');

  for (const headerKey of headers.keys()) {
    rb.header(headerKey, headers.get(headerKey));
  }

  return http
    .request(rb.build({ responseType: 'json', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LanguageListModel>;
      }),
    );
}

listLanguagesGet.PATH = '/api/v1/translation/languages';
